import { useIntegrationAccountTypeRouteApi } from './useIntegrationsRouteApi.js';

export const useIsAccountCreation = () => {
  const { tabName, type } = useIntegrationAccountTypeRouteApi().useParams();

  return tabName === 'accounts' && type === 'add';
};
